import React from "react";

/**
 * Doudou Alert logo - vectoriel (SVG) avec transparence réelle.
 */
export default function Logo({ size = 56, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <img
        src="/logo.svg"
        alt="Doudou Alert"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
          flexShrink: 0,
        }}
      />
      {withText && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-2xl font-black tracking-tight text-stone-800">
            Doudou Alert
          </span>
          <span className="text-[10px] tracking-[0.22em] uppercase font-bold text-rose-400 mt-1">
            Plus aucun doudou de perdu
          </span>
        </div>
      )}
    </div>
  );
}
